import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { RoleDto } from "@/core/features/roles/role.dto";
import { CreateRoleDto } from "@/core/features/roles/create-role.dto";
import { UpdateRoleDto } from "@/core/features/roles/update-role.dto";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class RolesResource extends ResourceBaseService<RoleDto, CreateRoleDto, UpdateRoleDto> {
  protected EntityDto = RoleDto;
  protected CreateEntityDto = CreateRoleDto;
  protected UpdateEntityDto = UpdateRoleDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/roles");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "name"] } : {};
    request.sortBy = "name";
    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((value) => value.mapEntityToOptionType([value.name]));
  }
}
